import { Injectable } from '@angular/core';
import { PatientPhysicalQADto } from 'src/app/shared/models/DTO/PatientPhysicalQADto';
import { PatientQuestionsAnswersDto } from 'src/app/shared/models/DTO/PatientQuestionsAnswersDto';
import { SSI4ExamEstimationDto } from 'src/app/shared/models/DTO/SSI4ExamEstimationDto';
import { VideoFrequencyDetailsDto } from 'src/app/shared/models/DTO/VideoFrequencyDetailsDto';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';

@Injectable({
  providedIn: 'root'
})
export class PatientExamsService {

  constructor(private httpRes: HttpRequestService) { }
  totalPoints:number = 0;
  totalansweredQuestions:number = 0;
  totalImpactdegree :number = 0;

  // get exam questions answers plus patient answers
  getExamQuestionsAnswersByExamCode(userId: string , ExamCode: string , stageId:number)
  {
      return this.httpRes.GetRequest(`PatientExams/GetExamQuestionsAnswersByExameCode/${userId}/${ExamCode}/${stageId}`);
  }

  AddPatientOasesExamAnswers(userId: string , patientQuestionsAnswers: PatientQuestionsAnswersDto[] , patientCurrentStage: number)
  {
      return this.httpRes.postRequest(`PatientExams/AddPatientOasesExamAnswers/${userId}/${patientCurrentStage}`, patientQuestionsAnswers);
  }

  AddPatientSSRSExamAnswers(userId: string , patientQuestionsAnswers: PatientQuestionsAnswersDto[], patientCurrentStage: number)
  {
      return this.httpRes.postRequest(`PatientExams/AddPatientSSRSExamAnswers/${userId}/${patientCurrentStage}`, patientQuestionsAnswers);
  }

  AddPatientSSI4ExamAnswers(examAnswer: any , file:any , patientCurrentStage: number)
  {
    const formData: FormData = new FormData();
    formData.append('record',file , file.name);

      return this.httpRes.postFile(`PatientExams/AddPatientSSI4ExamAnswers/${examAnswer.userId}/${examAnswer.examId}/${examAnswer.questionId}/${patientCurrentStage}`, formData);
  }
    // AddSSI4Estimation(userId: string , VideoFrequencyDetails: VideoFrequencyDetailsDto[] , physicalConcomitantsQA : PatientPhysicalQADto[])

  AddPatienPreTreatmentExamAnswers(userId: string , patientQuestionsAnswers: PatientQuestionsAnswersDto[])
  {
      return this.httpRes.postRequest(`PatientExams/AddPatienPreTreatmentExamAnswers/${userId}`, patientQuestionsAnswers);
  }

  AddPatienTreatmentSessionCognitiveExamAnswers(userId: string , patientQuestionsAnswers: PatientQuestionsAnswersDto[], stageId: number, stageDiagnosesId: number)
  {
    return this.httpRes.postRequest(`PatientExams/AddPatienTreatmentSessionCognitiveExamAnswers/${userId}/${stageId}/${stageDiagnosesId}`, patientQuestionsAnswers);
  }

  AddPatienVideoExamAnswer(examAnswer: any , file:any)
  {
    const formData: FormData = new FormData();
    formData.append('record',file , file.name);

      return this.httpRes.postFile(`PatientExams/AddPatienVideoExamAnswer/${examAnswer.userId}/${examAnswer.examId}/${examAnswer.questionId}/${examAnswer.stageId}`, formData);
  }

  AddPatienTreatmentSessionEvaluationExamAnswers(userId: string , patientQuestionsAnswers: PatientQuestionsAnswersDto[], stageId: number, stageDiagnosesId: number)
  {
    return this.httpRes.postRequest(`PatientExams/AddPatienTreatmentSessionEvaluationExamAnswers/${userId}/${stageId}/${stageDiagnosesId}`, patientQuestionsAnswers);
  }

  ApproveSessionAndAddSpecialistEvaluation(specialistSessionEvaluation :any)
  {
    return this.httpRes.postRequest(`PatientExams/ApproveSessionAndAddSpecialistEvaluation`, specialistSessionEvaluation);
  }

  RetakeSession(RetakenSessionData :any)
  {
    return this.httpRes.postRequest(`PatientExams/RetakeSession`, RetakenSessionData);
  }

  CalcTaskScore(PatientType: string , videoFrequencyDetails: VideoFrequencyDetailsDto)
  {
    return this.httpRes.postRequest(`PatientExams/CalcTaskScore/${PatientType}`, videoFrequencyDetails);
  }

  AddSSI4Estimation(userId: string , SSI4ExamEstimation: SSI4ExamEstimationDto , editableRole : string)
  {
    return this.httpRes.postRequest(`PatientExams/AddSSI4Estimation/${userId}/${editableRole}`, SSI4ExamEstimation);
  }

  // get Exam Result.
  GetPatientExamResultByExameCode(userId: string , ExamCode: string)
  {
      return this.httpRes.GetRequest(`PatientExamResult/GetPatientExamResultByExameCode/${userId}/${ExamCode}`);
  }

  // get All Exams Results.
  GetPatientAllExamResults(userId: string)
  {
      return this.httpRes.GetRequest(`PatientExamResult/GetPatientAllExamResults/${userId}`);
  }

  // Get Retaken Session added Notes by the specialist.
  GetRetakenSessionNotes(userId: string , examCode : string)
  {
      return this.httpRes.GetRequest(`PatientExamResult/GetRetakenSessionNotes/${userId}/${examCode}`);
  }

  // Get Taken Exam by the patient.
  GetTakenExams(userId: string)
  {
      return this.httpRes.GetRequest(`PatientExamResult/GetTakenExams/${userId}`);
  }

  calcExamOasesTotalResult(examOasesResult:any[]){
    examOasesResult.forEach(element => {
      this.totalPoints += element.points;
      this.totalansweredQuestions += element.answeredQuestions;
    });
    this.totalImpactdegree = this.totalPoints/this.totalansweredQuestions;

    let newRow = {
      answeredQuestions: this.totalansweredQuestions,
      description: null,
      diagnosisReportId: null,
      examCode: "EX_OASES",
      examId: 2055,
      id: null,
      impactDegree: this.totalImpactdegree,
      patientTakenDate: null,
      points: this.totalPoints,
      section: {
        exam: null,
        examId: 2055,
        extremeEnd: 5,
        extremeStart: 3.75,
        id: 1,
        lightEnd: 1.49,
        lightStart: 1,
        lightToMediumEnd: 2.24,
        lightToMediumStart: 1.5,
        mediumEnd: 2.99,
        mediumStart: 2.25,
        mediumToExtremeEnd: 3.74,
        mediumToExtremeStart: 3,
        questions: null,
        sectionName: "نتيجة التأثير الكلى"
      },
      sectionId: 1,
      specialistEditable: null,
      specialistEvaluationDate: null,
      stageId: examOasesResult[0]?.stageId,
      supervisorEditable: null,
      unitCode: null,
      unitName: null
    }
    examOasesResult.push(newRow);
    console.log("from serice : ", examOasesResult);
    this.totalPoints = 0;
    this.totalansweredQuestions = 0;
    this.totalImpactdegree  = 0;
  }

  // get SSI4 Duration Ranges
  GetSSI4DurationRanges()
  {
      return this.httpRes.GetRequest(`PatientExams/GetSSI4DurationRanges`);
  }

}
